import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { cn } from "@omni/utils/styles";

import { usePaintConfiguratorContext } from "@/components/PaintConfigurator/context/paintConfigurator.context";
import { Mapped } from "@/context/mapped.context";

const Base = ({ children }: RequireChildrenFor<{}>) => {
    const { steps } = usePaintConfiguratorContext();

    return (
        <div
            className={cn("tw:flex tw:gap-2 tw:items-center tw:justify-center")}
        >
            <Mapped array={steps}>{children}</Mapped>
        </div>
    );
};

export { Base };
